import { createFileRoute } from '@tanstack/react-router';
import { RouteStub } from '@/components/shared/RouteStub';

export const Route = createFileRoute('/admin')({
  component: () => (
    <RouteStub
      title="chainMuse — Witty staff admin"
      phase="Phase 2 — Admin"
      detail="Insurer onboarding, NFC fulfillment queue, enterprise plan provisioning, webhook error retry. Email-allowlist gated for Phase 2; full RBAC in Phase 5."
    />
  ),
});
